const defaultPlaceholder = `img/${import.meta.env.VUE_APP_HANDLE}/placeholder.jpg`;

export default {
  methods: {
    /**
     * Format image url.
     *
     * @param {String} uri
     * @param {String} placeholder
     *
     * @return {String}
     */
    imageUrl(uri, placeholder) {
      return uri ? `${import.meta.env.VUE_APP_ASSET_URL}${uri}` : placeholder || defaultPlaceholder;
    },
  },
};
